import '@/styles/common/Mypage/assetsbox.scss';

import React, { VFC } from 'react';

import { MypageUploadfileList } from './List';
import { TooltipMessageMatchbou } from '@/components/common/Tooltip/Matchbou';
import { ButtonIconButton } from '@/components/common/Button/IconButton';
import { ButtonTextLink } from '@/components/common/Button/TextLink';

type TMypageUploadfileListProps = React.ComponentProps<typeof MypageUploadfileList>;

type TProps = {
  className?: string;
  resume?: TMypageUploadfileListProps | null;
  career?: TMypageUploadfileListProps | null;
};

/**
 *
 * https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=383%3A35945
 *
 */
export const MypageUploadfileBox: VFC<TProps> = ({ className = '', resume, career }) => {
  return (
    <section className={'bg-gray-50 lg:mb-80 sm:px-24 py-40 px-40 mx-auto ' + className}>
      <div className="flex">
        <h1 className="font-bold text-14_20">自作の履歴書・職務経歴書の登録</h1>
      </div>
      <p className="text-12_20 mt-8">
        自作の履歴書・職務経歴書をお持ちの場合、登録（アップロード）することでマイナビワークスのキャリアアドバイザーに見せることができ、企業へのアピールにつながります。
      </p>
      <div className="mt-8">
        <hr className="mbx-keyline-horizontal--thin"></hr>
        <div className="lg:flex items-center justify-between py-12">
          {!resume && !career ? (
            <p className="text-12_20">未登録</p>
          ) : (
            <div className="text-12_20 flex-1">
              <div className="flex">
                <p className="w-80 flex-none">履歴書 :</p>
                <div className="min-w-0">
                  {resume ? (
                    <div className="lg:flex items-center">
                      <p className="mr-16 flex-none">{resume.date}</p>
                      <div className="flex items-center min-w-0">
                        <p className="truncate">{resume.name}</p>
                        <p className="flex-none">({resume.size})</p>
                      </div>
                    </div>
                  ) : (
                    <>未登録</>
                  )}
                </div>
              </div>
              <div className="flex mt-8">
                <p className="w-80 flex-none">職務経歴書 :</p>
                <div className="min-w-0">
                  {career ? (
                    <div className="lg:flex items-center">
                      <p className="mr-16 flex-none">{career.date}</p>
                      <div className="flex items-center min-w-0">
                        <p className="truncate">{career.name}</p>
                        <p className="flex-none">({career.size})</p>
                      </div>
                    </div>
                  ) : (
                    <>未登録</>
                  )}
                </div>
              </div>
            </div>
          )}
          <p className="w-86 shrink-0 text-12_20 sm:mt-12 lg:text-right">
            <ButtonTextLink href="/mypage/self-resume-cv/edit">設定の変更</ButtonTextLink>
          </p>
        </div>
        <hr className="mbx-keyline-horizontal--thin"></hr>
      </div>
    </section>
  );
};
